"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
const groupNames = __importStar(require("../group-names"));
const KnownProperties = __importStar(require("./../known-properties"));
function propertyDefinition(pvs) {
    return [
        {
            sort_no: 0,
            name: KnownProperties.fanControlMode,
            group: groupNames.fanControlMode,
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 2,
                    value: {
                        type: "integer",
                        value: 2
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 1,
            name: KnownProperties.fanQuantity,
            group: groupNames.fanQuantity,
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 1,
            name: KnownProperties.fanDefinitionSpeed,
            group: groupNames.fanDefinition,
            quantity: "Frequency",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: KnownProperties.fanDefinitionStandardDensity,
            group: groupNames.fanDefinition,
            quantity: "Density",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 1,
            name: KnownProperties.fanOutletArea,
            group: groupNames.fanPerformanceMmodel,
            quantity: "Area",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: KnownProperties.fanDynamicPressureLossCoefficient,
            group: groupNames.fanPerformanceMmodel,
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 3,
            name: KnownProperties.motorInputPower,
            group: groupNames.motorDefinition,
            quantity: "Power",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 3,
            name: KnownProperties.motorVoltage,
            group: groupNames.motorDefinition,
            quantity: "ElectricPotential",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 4,
            name: KnownProperties.motorPhases,
            group: groupNames.motorDefinition,
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 5,
            name: KnownProperties.motorPoles,
            group: groupNames.motorDefinition,
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 6,
            name: KnownProperties.motorGridPowerExponent,
            group: groupNames.motorDefinition,
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 7,
            name: KnownProperties.motorCosphi,
            group: groupNames.motorDefinition,
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 1,
            name: KnownProperties.fanMinimumSpeed,
            group: groupNames.fanOperationalRange,
            quantity: "Frequency",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: KnownProperties.fanMaximumSpeed,
            group: groupNames.fanOperationalRange,
            quantity: "Frequency",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 1,
            name: KnownProperties.targetPressure,
            group: groupNames.target,
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString(`${KnownProperties.fanControlMode}=1`),
            value: []
        },
        {
            sort_no: 1,
            name: KnownProperties.airInputsMassflow,
            group: groupNames.airInput,
            quantity: "MassFlow",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 1,
            name: KnownProperties.airInputsTemperature,
            group: groupNames.airInput,
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: KnownProperties.airInputsHumidity,
            group: groupNames.airInput,
            quantity: "RelativeHumidity",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [],
            conversionParameters: {
                pressure: property_1.PropertyValueSet.getAmount(KnownProperties.airInputsPressure, pvs),
                temperature: property_1.PropertyValueSet.getAmount(KnownProperties.airInputsTemperature, pvs)
            }
        },
        {
            sort_no: 3,
            name: KnownProperties.airInputsPressure,
            group: groupNames.airInput,
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 5,
            name: KnownProperties.actualDensity,
            group: groupNames.airInput,
            quantity: "Density",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
//# sourceMappingURL=airinputs-definition.js.map